module.exports = __webpack_public_path__ + "img/checkbox-checked-error.9504c23.svg";